import React, { Component } from 'react';
import { Table, TableRow, TableCell, TableBody } from '@material-ui/core';
import withUser from '../HOC/HOCwithUser.jsx';
import HOCLoader from '../HOC/HOCLoader.jsx';
import { getStatus, ROLE_PROVIDER } from '../../utils/config/constants.js';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';

export class BasicCustomerProfile extends Component {
    render() {
        const { userData, settings } = this.props;
        return (
            <HOCLoader loading={this.props.isLoading}>
                <div className="text-center arab-table tz-db-table">
                    <Table className="table bordered">
                        <TableBody>
                            <TableRow>
                                <TableCell className="text-left">
                                    <FormattedMessage
                                        id="name"
                                        defaultMessage="Name"
                                    />
                                    :
                                </TableCell>
                                <TableCell className="text-left">
                                    {userData.name}
                                </TableCell>
                            </TableRow>

                            {userData.role == ROLE_PROVIDER && (
                                <React.Fragment>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="businessName"
                                                defaultMessage="Business Name"
                                            />
                                            :
                                        </TableCell>
                                        <TableCell className="text-left">
                                            {userData.businessName}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="website"
                                                defaultMessage="Website"
                                            />
                                            :
                                        </TableCell>
                                        <TableCell className="text-left">
                                            {userData.website}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="text-left">
                                            <FormattedMessage
                                                id="establishedOn"
                                                defaultMessage="Established On"
                                            />
                                            :
                                        </TableCell>
                                        <TableCell className="text-left">
                                            {userData.establishedOn
                                                ? moment
                                                      .unix(
                                                          userData.establishedOn /
                                                              1000
                                                      )
                                                      .format('DD-MM-YYYY')
                                                : ''}
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            )}
                            <TableRow>
                                <TableCell className="text-left">
                                    <FormattedMessage
                                        id="email"
                                        defaultMessage="Email"
                                    />
                                    :
                                </TableCell>
                                <TableCell className="text-left">
                                    {userData.email}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="text-left">
                                    <FormattedMessage
                                        id="phone"
                                        defaultMessage="Phone"
                                    />{' '}
                                    :
                                </TableCell>
                                <TableCell className="text-left">
                                    {userData.phone}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="text-left">
                                    <FormattedMessage
                                        id="status"
                                        defaultMessage="Status"
                                    />
                                    :
                                </TableCell>
                                <TableCell className="text-left">
                                    {getStatus(userData.status)}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="text-left">
                                    <FormattedMessage
                                        id="createdAt"
                                        defaultMessage="Created At"
                                    />
                                    :
                                </TableCell>
                                <TableCell className="text-left">
                                    {moment(userData.created_at).format(
                                        'DD-MMM-Y hh:mm:ss'
                                    )}
                                </TableCell>
                            </TableRow>
                            {userData.role == ROLE_PROVIDER && (
                    <TableRow>
                    <TableCell className="text-left">
                        <FormattedMessage
                            id="dueAmount"
                            defaultMessage="Due Amount"
                        />
                        :
                    </TableCell>
                    <TableCell className="text-left">
                    {settings.constants.CURRENCY_SYMBOL}  {(userData.due_amount)}
                    </TableCell>
                </TableRow>
                )}
                        </TableBody>
                    </Table>
                </div>
            </HOCLoader>
        );
    }
}

export default withUser(BasicCustomerProfile);



// WEBPACK FOOTER //
// ./src/components/Customer/BasicCustomerProfile.jsx